import React, {forwardRef, useState} from "react";
import {Button as MuiButton} from '@mui/material';

/**
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<Omit<import("@mui/material").ButtonProps, "color" | "variant"> & {
 * readonly color?: "primary" | "secondary" | "tertiary" | 'error',
 * readonly variant?: 'text' | 'outlined' | 'contained' | "dialog",
 * readonly hoverChildren?: ReactNode,
 * readonly borderRadius?: string,
 * }> & React.RefAttributes<HTMLButtonElement>>}
 */
const Button = forwardRef(({
                               color,
                               children,
                               hoverChildren,
                               borderRadius,
                               ...props
                           }, ref) => {
    const [hovering, setHovering] = useState(false);

    const onMouseEnter = (e) => {
        setHovering(true)
        if (props?.onMouseEnter) {
            props.onMouseEnter(e);
        }
    }

    const onMouseLeave = (e) => {
        setHovering(false)
        if (props?.onMouseLeave) {
            props.onMouseLeave(e);
        }
    }

    const onMouseDown = (e) => {
        e.stopPropagation();
        if (props?.onMouseDown) {
            props.onMouseDown(e);
        }
    }

    return (
        <MuiButton
            disableElevation
            {...props}
            ref={ref}
            color={color}
            style={{...(borderRadius && {borderRadius: borderRadius}), ...(props?.style ?? {})}}
            onMouseDown={onMouseDown}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {
                hovering
                    ? hoverChildren ?? children
                    : children
            }
        </MuiButton>
    );
});

export default Button;
